import React from 'react';
import { motion, useScroll, useSpring } from 'framer-motion';

/**
 * ScrollProgress — 1px fjord/70 line under the navbar that fills 0→100%
 * as the user scrolls the document. useSpring smooths the raw progress so
 * the fill motion feels organic, not linear-jittery.
 *
 * Positioned via CSS `top-14 md:top-16` to sit flush under the sticky navbar
 * (mobile h-14 / desktop h-16). z-index sits UNDER the navbar (40 vs 50)
 * so any navbar shadow visually clears the line.
 *
 * aria-hidden: purely decorative — no semantic content, no keyboard target.
 */
export default function ScrollProgress() {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 100,
    damping: 30,
    restDelta: 0.001,
  });

  return (
    <motion.div
      aria-hidden="true"
      data-testid="scroll-progress"
      className="fixed left-0 right-0 top-14 md:top-16 h-[1px] bg-fjord/70 origin-left pointer-events-none z-40"
      style={{ scaleX }}
    />
  );
}
